import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

export default function ConfirmFullImportDialog({
  open,
  fileName,
  loading,
  onClose,
  onConfirm,
}) {
  const handleClose = () => {
    if (!loading) {
      onClose?.();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Potwierdź pełny import</DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          <Alert severity="warning">
            Dostawy nieobecne w nowym pliku zostaną usunięte z aktywnej kolejki
            miksów.
          </Alert>

          <Typography>
            Potwierdź, że plik zawiera pełny aktualny zakres dostaw.
          </Typography>

          {fileName && (
            <Typography variant="body2" color="text.secondary">
              Wybrany plik: <strong>{fileName}</strong>
            </Typography>
          )}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Anuluj
        </Button>

        <Button
          variant="contained"
          color="warning"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            'Potwierdzam i importuję'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
